module.exports = __webpack_public_path__ + "img/admin_adv_07.b16a2226.png";